export default {
  text: {
    en: 'Add your first product to the queue before it’s packed and shipped',
  },
}
